import { SCALE } from '../../constants';
import podiumImg from '@/assets/image/pdfexport/podium.png';
import Box from '@material-ui/core/Box';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';

const ContainerBox = withStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    gap: 4 * SCALE,
  },
})(Box);

const AvatarBox = withStyles({
  root: {
    background: '#e2f2ff',
    width: 34 * SCALE,
    height: 34 * SCALE,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& img': {
      width: 20 * SCALE,
      height: 20 * SCALE,
    },
  },
})(Box);

const TitleBox = withStyles({
  root: {
    background: '#e2f2ff',
    height: 34 * SCALE,
    borderRadius: 100,
    fontFamily: 'OpenSans',
    fontWeight: 600,
    fontSize: 14 * SCALE,
    color: '#333333',
    lineHeight: `${20 * SCALE}px`,
    letterSpacing: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start',
    paddingLeft: `${20 * SCALE}px`,
    width: '100%',
  },
})(Box);

const CRPreviewSection = ({ title, img = podiumImg }) => {
  return (
    <ContainerBox>
      <AvatarBox>
        <img src={img} alt="avatar" />
      </AvatarBox>
      <TitleBox>{title}</TitleBox>
    </ContainerBox>
  );
};

export default CRPreviewSection;
